// Keyboard shortcut help (legacy ShortcutKeysComponent, ctrl+shift+k).

import { Box, Chip, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { CloseCircle } from 'iconsax-reactjs';

import { t } from '../../../i18n';
import { SHORTCUTS, ShortcutCombo, comboText, shortcutLabel } from '../shortcuts';

const GROUPS: Array<{ combos: ShortcutCombo[]; titleKey: string }> = [
  { combos: ['alt+shift', 'alt+meta'], titleKey: 'shell.shortcuts.add' },
  { combos: ['ctrl+shift', 'ctrl+meta'], titleKey: 'shell.shortcuts.list' },
  { combos: ['ctrl+alt'], titleKey: 'shell.shortcuts.general' }
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {t('shell.shortcuts')}
        <IconButton onClick={onClose} aria-label={t('action.close')}>
          <CloseCircle size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2.5}>
          {GROUPS.map((group) => {
            const items = SHORTCUTS.filter((s) => group.combos.includes(s.combo));
            const extra = group.titleKey === 'shell.shortcuts.general' ? [{ text: '⌘K / Ctrl+K', label: t('shell.commandPalette') }] : [];
            return (
              <Box key={group.titleKey}>
                <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700 }}>
                  {t(group.titleKey)}
                </Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, gap: 0.75, mt: 0.5 }}>
                  {[...items.map((s) => ({ text: comboText(s), label: shortcutLabel(s) })), ...extra].map((row) => (
                    <Stack key={row.text + row.label} direction="row" spacing={1} alignItems="center">
                      <Chip size="small" label={row.text} variant="outlined" sx={{ fontFamily: 'monospace', minWidth: 74 }} />
                      <Typography variant="body2" noWrap>
                        {row.label}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Box>
            );
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
